import React, { Component } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { Typography } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import UserAdministrationDataAccess from '../services/UserAdministrationDataAccess';
import Auth from '../services/auth';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Snackbar from '@material-ui/core/Snackbar';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';


const userAdminDataAccess = new UserAdministrationDataAccess();
const auth = new Auth();

const styles = theme => ({
    root: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
    },
    paper: {
        padding: theme.spacing(2),
        color: theme.palette.text.secondary,
    },
    paperReports: {
        padding: theme.spacing(2),
        color: theme.palette.text.secondary,
        height: '100%',
        maxHeight: 324,
        overflow: 'auto'
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: '100%',
    }
    ,
    textFieldSm: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: '50%',
    },
    downRoot: {
        flexGrow: 1,
        height: 250,
    },
    downContainer: {
        flexGrow: 1,
        position: 'relative',
    },
    downPaper: {
        position: 'absolute',
        zIndex: 1,
        marginTop: theme.spacing(1),
        left: 0,
        right: 0,
    },
    downChip: {
        margin: `${theme.spacing(1) / 2}px ${theme.spacing(1) / 4}px`,
    },
    downInputRoot: {
        flexWrap: 'wrap',
    },
    downDivider: {
        height: theme.spacing(2),
    },
});

class UserAdminDetail extends Component {

    constructor(props) {
        super(props);

        const isAddUser = this.props.match.params.id === "0";

        this.state = {
            id: this.props.match.params.id,
            isLoading: false,
            openSnack: false,
            snackMessage: "",
            user: {
                AAUserId: "",
                FirstName: "",
                LastName: "",
                IsAdminUser: false,
                IsWizardAccess: false,
                Email: ""
            },
            mapping: [],
            hasAccess: auth.isInADDGroup(),
            isAddUser: isAddUser
        };

        let self = this;
        if (!isAddUser) {
            userAdminDataAccess.getUserList(self.state.id).then((rs) => {
                if (rs) {
                    const user = rs[0];

                    self.setState({
                        user: {
                            ...user,
                            IsAdminUser: user.IsAdminUser ?? auth.isInADDGroup(),
                            IsWizardAccess: user.IsWizardAccess ?? auth.isInEOMWizardGroup()
                        },
                        isLoading: false
                    });

                    userAdminDataAccess.getClientMapping(self.state.id).then((rsmap) => {
                        if (rsmap) {
                            self.setState({ mapping: rsmap });
                        }
                    });
                } else {
                    this.handleError("No client were selected ");
                    this.setState({ isLoading: false });
                }
            });
        }
    }

    componentDidMount() {
        document.title = 'User Administration Detail - Surgical Notes RCM';
    }

    handleError = (error) => {
        // Log the error to Application Insights
        AppInsights.trackException({ exception: error });
    };

    handleSave = async () => {
        try {

            const { user, id } = this.state;

            const { AAUserId, FirstName, LastName, IsAdminUser, IsWizardAccess, Email } = user;

            let OperationType = id === "0" ? 1 : 2;

            const payload = { AAUserId, FirstName, LastName, IsAdminUser, IsWizardAccess, Email, OperationType };

            const response = await userAdminDataAccess.processUserAdmin(payload);

            if (OperationType === 1 && response?.data?.[0]?.newAAuserId) {
                    const newId = response.data[0].newAAuserId;

                    this.setState(prevState => ({
                        id: newId,
                        user: {
                            ...prevState.user,
                            AAUserId: newId
                        }
                    }));
            }

            this.setState({ snackMessage: "User updated successfully", openSnack: true });

        } catch (error) {
            this.handleError(error);
        }
    };

    render() {

        const { classes } = this.props;
        const {
            openSnack,
            snackMessage,
            hasAccess
        } = this.state;

        if (!hasAccess) {
            return <Redirect to="/" />;
        }

        return (
            <div style={{ paddingBottom: 250 }}>
                <Snackbar
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                        open={openSnack}
                        autoHideDuration={3000}
                        ContentProps={{
                            'aria-describedby': 'message-id',
                        }}
                        message={<span id="message-id">{snackMessage}</span>}
                    />
                <Grid container className={classes.root} spacing={2}>
                    <Grid item xs={12}>
                        <Paper className={classes.root}>

                            <Typography className={classes.title} color="textPrimary" gutterBottom>
                                User Administrator Detail
                            </Typography>

                            <Typography className={classes.title} color="textSecondary">
                                Change the Administrator and Wizard Access properties.

                            </Typography>

                            <Grid container spacing={2}>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        id="firstName"
                                        label="First Name"
                                        className={classes.textField}
                                        margin="normal"
                                        name="confidenceScore"
                                        variant="outlined"
                                        value={this.state.user.FirstName}
                                        type="text"
                                        fullWidth
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        disabled={!this.state.isAddUser}
                                        onChange={(e) => {
                                            this.setState({
                                                user: {
                                                    ...this.state.user,
                                                    FirstName: e.target.value
                                                }
                                            });
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        id="lastName"
                                        label="Last Name"
                                        className={classes.textField}
                                        margin="normal"
                                        name="confidenceScore"
                                        variant="outlined"
                                        value={this.state.user.LastName}
                                        type="text"
                                        fullWidth
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        disabled={!this.state.isAddUser}
                                        onChange={(e) => {
                                            this.setState({
                                                user: {
                                                    ...this.state.user,
                                                    LastName: e.target.value
                                                }
                                            });
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        id="email"
                                        label="Email"
                                        className={classes.textField}
                                        margin="normal"
                                        name="confidenceScore"
                                        variant="outlined"
                                        value={this.state.user.Email}
                                        type="text"
                                        fullWidth
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        disabled={!this.state.isAddUser}
                                        onChange={(e) => {
                                            this.setState({
                                                user: {
                                                    ...this.state.user,
                                                    Email: e.target.value
                                                }
                                            });
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <FormControl component="fieldset" className={classes.formControl}>
                                        <FormGroup row>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox checked={!!this.state.user?.IsAdminUser}
                                                        onChange={(e) =>
                                                            this.setState({
                                                                user: {
                                                                    ...this.state.user,
                                                                    IsAdminUser: e.target.checked
                                                                }
                                                            })
                                                        }
                                                        color="primary"
                                                    />
                                                }
                                                label="Administrator"
                                            />
                                            <FormControlLabel
                                                control={
                                                    <Checkbox checked={!!this.state.user?.IsWizardAccess}
                                                        onChange={(e) =>
                                                            this.setState({
                                                                user: {
                                                                    ...this.state.user,
                                                                    IsWizardAccess: e.target.checked
                                                                }
                                                            })
                                                        }
                                                        color="primary"
                                                    />
                                                }
                                                label="Wizard Access"
                                            />
                                        </FormGroup>
                                    </FormControl>
                                </Grid>

                                <Grid item xs={12}>
                                    <Typography className={classes.title} color="textPrimary" gutterBottom>
                                        Client Mapping
                                    </Typography>
                                    <TableContainer component={Paper}>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>Client</TableCell>
                                                    <TableCell>Manager</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {this.state.mapping?.map((cm, idx) => (
                                                    <TableRow key={idx}>
                                                        <TableCell>{cm.Client}</TableCell>
                                                        <TableCell>{cm.Manager}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>

                                <Grid item xs={12}>
                                    <Grid container spacing={2} justify="flex-end">
                                        <Grid item>
                                            <Button
                                                className={classes.textField}
                                                variant="contained" color="primary"
                                                onClick={() => { this.props.history.push('/UserAdmin'); }}
                                            >
                                                Cancel
                                            </Button>
                                        </Grid>

                                        <Grid item>
                                            <Button
                                                className={classes.textField}
                                                variant="contained"
                                                color="primary"
                                                disabled={!auth.isInADDGroup()}
                                                onClick={this.handleSave}
                                            >
                                                Save
                                            </Button>
                                        </Grid>

                                    </Grid>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>

                </Grid>
            </div>
        );
    }
}
export default withStyles(styles, { withTheme: true })(UserAdminDetail);